export default "/static/webpack/media/eye.91cd4dd9.svg";